import { atom } from 'recoil';

// 버전 업데이트 모달 표시 여부 전역 상태
export const versionUpdateModalState = atom<boolean>({
  key: 'versionUpdateModalState',
  default: false,
});

